import { SessionSettingsModel } from "@/models";
import { MODULES, vuexName } from "@/store/utils";
import type { Commit } from "vuex";
import { DEFAULT_SESSION_CHANNEL_KEY } from "@/ws";

export const applySettings = (commit: Commit, settings: SessionSettingsModel | null | undefined) => {
  commit(vuexName(MODULES.REALTIME_SETTINGS.COMMITS.SET_SETTINGS), settings ?? null, { root: true });

  if (!settings) {
    return;
  }

  commit(vuexName(MODULES.CALLING.COMMITS.SET_ENABLED_AGORA_NOISE_CANCELLING), settings.isNoiseCanceling, { root: true });

  if (settings.videoCallQuality) {
    commit(vuexName(MODULES.CALLING.COMMITS.SET_VIDEO_CALLING_QUALITY), settings.videoCallQuality, { root: true });
  }

  commit("setEnabledFeatures", settings.features ?? [DEFAULT_SESSION_CHANNEL_KEY], { root: true });
};
